import { getSubtleSurfaceBackground } from '@app/core/ui/subtle-surface';
import { BoxProps } from '@mui/material';
import { ContentBox } from '../base/ContentBox';

/**
 * Full-width toolbar strip below the screen header.
 * Uses a light gray background and bottom border so it reads as a distinct bar
 * (e.g. filter bar, time navigation). Reused by list views and logger stream.
 */
export function PageToolbar(props: BoxProps) {
  return (
    <ContentBox
      {...props}
      sx={{
        position: 'relative',
        pt: 1.25,
        pb: 1.25,
        backgroundColor: getSubtleSurfaceBackground,
        borderBottom: 1,
        borderColor: 'divider',
        ...props.sx,
      }}
    />
  );
}
